module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "skynet.be"
];
